module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0005.jpg?v=0eff66f0";